var map = {
	"./csv.svg": 99047,
	"./excel.svg": 38825,
	"./images.svg": 95143,
	"./pdf.svg": 13273,
	"./power-point.svg": 67480,
	"./unknown.svg": 26006,
	"./word.svg": 90087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2569;